export default __webpack_public_path__ + "static/media/icon-nurse.38da6ae4.svg";